import { render, staticRenderFns } from "./SponsorCodeModal.vue?vue&type=template&id=60661c3a&"
import script from "./SponsorCodeModal.vue?vue&type=script&lang=js&"
export * from "./SponsorCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports